export default "__VITE_ASSET__CatLHeNm__"